import React, { FC, useCallback } from 'react';
import get from 'lodash/get';
import classNames from 'classnames';

import Menu from 'vibo-ui/Menu';
import UserRole from './UserRole';
import Button from 'vibo-ui/Button';
import Dropdown from 'vibo-ui/Dropdown';
import CellName from 'components/common/CellName';
import CustomLabel from 'components/labels/CustomLabel';
import ContentArea from 'components/common/ContentArea';
import UserImage from 'components/user/images/UserImage';

import { useModal } from 'vibo-ui/Modal';
import { isUserProTier } from 'utils/helpers/users';
import { getFullName } from 'services/users/helpers';

import { GET_USER_SESSIONS_FOR_ADMIN } from 'graphql/queries/user';
import { DROP_SESSIONS_FOR_USERS, DROP_ALL_SESSIONS_FOR_USER } from 'graphql/mutations/user';

import { Modals } from 'types/enums';
import { UserRowProps } from './interfaces';
import { UpdateUserModalProps } from 'components/modals/UpdateUserModal';
import { CustomLabelTypes } from 'components/labels/CustomLabel/interfaces';

import useStyles from './style';

import { IconmoonFont } from 'vibo-ui/Icon';

const UserRow: FC<UserRowProps> = ({ user }) => {
  const classes = useStyles();

  const fullName = getFullName(user);

  const isPro = isUserProTier(user.tier);

  const { openModal } = useModal();

  const openUpdateUserModal = () =>
    openModal<UpdateUserModalProps>({
      key: Modals.updateUser,
      props: {
        user,
      },
    });

  const openSessionsModal = useCallback(
    () =>
      openModal({
        key: Modals.sessions,
        props: {
          sessionsQuery: GET_USER_SESSIONS_FOR_ADMIN,
          dropSessionMutation: DROP_SESSIONS_FOR_USERS,
          dropAllSessionMutation: DROP_ALL_SESSIONS_FOR_USER,
          variables: {
            userId: user._id,
          },
        },
      }),
    [user._id]
  );

  return (
    <ContentArea
      className={classNames('userRow', classes.userRow)}
      // onClick={openUpdateUserModal}
      shadowed
    >
      <CellName name="photo">
        <UserImage
          user={user as UserBase}
          src={get(user, 'image.cropped.small', '')}
          loadMs={400}
        />
      </CellName>
      <CellName name="name" title={fullName}>
        <div className="fullName">{fullName}</div>
        <div className="email">{user.email}</div>
      </CellName>
      <CellName name="role">
        <UserRole user={user} />
      </CellName>
      <CellName name="tier" title={user.tier[0].name}>
        {user.tier[0].name}
      </CellName>
      <CellName name="finance-status">{user.djSettings?.financeStatus}</CellName>
      <CellName name="tools">
        <Dropdown
          overlay={
            <Menu selectable={false}>
              <Menu.Item onClick={openUpdateUserModal}>Edit profile</Menu.Item>
              <Menu.Item onClick={openSessionsModal}>Session management</Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger="click"
        >
          <Button prefixIcon={IconmoonFont['threeDots-16']} shape="round" size="lg" />
        </Dropdown>
      </CellName>
      {isPro ? (
        <CustomLabel
          type={CustomLabelTypes.success}
          className={classNames(classes.proTierLabel, 'filled')}
        >
          PRO
        </CustomLabel>
      ) : null}
    </ContentArea>
  );
};

export default UserRow;
